import { useEffect } from 'react'
import 'react-reflex/styles.css'
import { paneMaxHeight } from '../../../../pages/[lang]/portal/lessons/preparation/[lessonId]'
import useQuestionStore from '../../../../store/useQuestionStore'
import { TAB } from '../../../materials/const'
import { QuestionSelectPanel } from '../../materials/QuestionSelect/QuestionSelectPanel'
import { DocNoteTabPanel } from '../../review/DocNoteTabPanel'

interface RightBodyProps {
  iframeRef: any
  lesson: any
  currentUser: any
  currentTabSub: any
  isEditable: any
  setIsEditable: any
  setTabData: any
  answer: any
  setAnswer: any
  selectedShareState: any
  setSelectedShareState: any
  activeQuestionId: any
  setActiveQuestionId: any
  isReview?: any
}

const RightBody = ({
  iframeRef,
  lesson,
  currentUser,
  currentTabSub,
  isEditable,
  setIsEditable,
  setTabData,
  answer,
  setAnswer,
  selectedShareState,
  setSelectedShareState,
  activeQuestionId,
  setActiveQuestionId,
  isReview = false,
}: RightBodyProps) => {
  const reset = useQuestionStore((state) => state.reset)

  useEffect(() => {
    return () => {
      reset()
    }
  }, [])

  return (
    <div style={{ maxHeight: paneMaxHeight }} className="no-scrollbar mt-[16px]">
      <div>
        {currentTabSub === TAB.QUESTION_SELECT ? (
          <QuestionSelectPanel
            currentUser={currentUser}
            isReview={isReview}
            isLesson={isReview}
            isEditable={isEditable}
            setIsEditable={setIsEditable}
            setTabData={setTabData}
            answer={answer}
            setAnswer={setAnswer}
            selectedShareState={selectedShareState}
            setSelectedShareState={setSelectedShareState}
            activeQuestionId={activeQuestionId}
            setActiveQuestionId={setActiveQuestionId}
          />
        ) : (
          <div>
            <DocNoteTabPanel
              documentUrl={lesson?.document_url}
              ringledocUrl={lesson?.ringledoc_url}
              iframeRef={iframeRef}
              ringleDocToken={lesson?.ringledoc}
              currentUser={currentUser}
              specialLesson={lesson?.special_lesson}
              height={'calc(100vh - 123px)'}
              style={'border-0 w-h-full w-full h-full'}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default RightBody
